/** Whether the keyboard's command key is ⌘ (Apple) or Ctrl (everyone else). */
export const isApple = () => /Mac|iPhone|iPad/.test(navigator.platform);
/** The command key as it is printed on the person's keyboard: „⌘“ or „Strg“. */
export const modifierKey = () => (isApple() ? '⌘' : 'Strg');
/** Whether a key press holds the command key - ⌘ on Apple, Ctrl elsewhere, either accepted. */
export const withModifier = (event) => event.metaKey || event.ctrlKey;
//# sourceMappingURL=keyboard.js.map